import React, { useRef, useState, useEffect } from 'react';
import Hls from 'hls.js';

// Componente che riceve l'URL completo, ma con logica HLS identica a VideoPlayerHls
const VideoPlayerHlsSingoloFlusso = ({ videoStreaming }) => {
  const videoRef = useRef(null);
  // const [videoSrc, setVideoSrc] = useState(videoStreaming); // Non serve più stato interno per src
  const [reloadTrigger, setReloadTrigger] = useState(false); // Usa booleano come in VideoPlayerHls
  const [isPictureInPictureActive, setIsPictureInPictureActive] = useState(false);

  // Rimosso useEffect per impostare videoSrc, usiamo direttamente videoStreaming

  //console.log(`[SingoloFlusso] URL VIDEO da prop: ${videoStreaming}`);

  useEffect(() => {
    let hls = null;
    let reloadTimeoutId = null; // Variabile per memorizzare l'ID del timeout

    const initializeHls = () => {
      // Usa direttamente la prop videoStreaming, controllando che sia valida
      if (!videoStreaming || typeof videoStreaming !== 'string' || !videoStreaming.includes('.m3u8')) {
        console.warn('[SingoloFlusso] URL prop non valido o non fornito:', videoStreaming);
        return;
      }

      if (Hls.isSupported()) {
        //console.log(`[SingoloFlusso] Inizializzo HLS per: ${videoStreaming}`);
        hls = new Hls();
        hls.loadSource(videoStreaming); // Usa direttamente la prop
        hls.attachMedia(videoRef.current);

        // Gestione Errori (identica a VideoPlayerHls)
        hls.on(Hls.Events.ERROR, function (event, data) {
            console.error(`[SingoloFlusso] Errore HLS (${data.type}):`, data.details, videoStreaming);
          if (data.fatal) {
             console.error('[SingoloFlusso] Errore fatale HLS');
            if (data.type !== Hls.ErrorTypes.NETWORK_ERROR || data.details !== Hls.ErrorDetails.MANIFEST_PARSING_ERROR) {
                console.warn('[SingoloFlusso] Tento reload dopo errore fatale...');
                // Cancella un timeout precedente se esiste
                if (reloadTimeoutId) {
                    clearTimeout(reloadTimeoutId);
                }
                // Imposta il nuovo timeout e salva l'ID
                reloadTimeoutId = setTimeout(() => {
                    //console.log('[SingoloFlusso] Eseguo reload triggerato da timeout');
                    setReloadTrigger(prevState => !prevState)
                }, 5000);
            }
          }
        });

        hls.on(Hls.Events.MANIFEST_PARSED, function () {
          //console.log(`[SingoloFlusso] Manifest parsed per: ${videoStreaming}`);
          if (videoRef.current) {
            // Rimuovi listener precedente se esiste
            const currentListener = videoRef.current.__playVideoListener;
            if (currentListener) {
                videoRef.current.removeEventListener('loadedmetadata', currentListener);
            }
            // Definisci e aggiungi nuovo listener
            const newListener = () => { playVideo(); };
            videoRef.current.addEventListener('loadedmetadata', newListener);
            videoRef.current.__playVideoListener = newListener; // Salva riferimento
          }
        });

      } else if (videoRef.current && videoRef.current.canPlayType('application/vnd.apple.mpegurl')) {
          // Fallback HLS Nativo (mantenuto per coerenza, anche se VideoPlayerHls non lo aveva esplicitamente)
          //console.log(`[SingoloFlusso] HLS non supportato via JS, uso supporto nativo per: ${videoStreaming}`);
          videoRef.current.src = videoStreaming;
          // Aggiungi listener anche qui
          const currentListener = videoRef.current.__playVideoListener;
          if (currentListener) {
              videoRef.current.removeEventListener('loadedmetadata', currentListener);
          }
          const newListener = () => { playVideo(); };
          videoRef.current.addEventListener('loadedmetadata', newListener);
          videoRef.current.__playVideoListener = newListener;

      } else {
        console.error('[SingoloFlusso] Questo browser non supporta HLS');
      }
    };

    // Funzione Play (identica a VideoPlayerHls)
    const playVideo = () => {
      if (videoRef.current) {
        //console.log(`[SingoloFlusso] Tento play per: ${videoStreaming}`);
        const playPromise = videoRef.current.play();
        if (playPromise !== undefined) {
          playPromise.then(() => {
            //console.log(`[SingoloFlusso] Play avviato per: ${videoStreaming}`);
            if (isPictureInPictureActive && document.pictureInPictureElement !== videoRef.current) {
              videoRef.current.requestPictureInPicture().catch(error => {
                console.error('[SingoloFlusso] Errore riattivazione PiP:', error);
              });
            }
          }).catch(error => {
             if (error.name !== 'AbortError') {
                console.error(`[SingoloFlusso] Errore play per: ${videoStreaming}`, error);
             }
          });
        }
      }
    };

    // Gestori PiP (identici a VideoPlayerHls)
    const handleLeavePictureInPicture = () => {
      //console.log('[SingoloFlusso] Uscito da PiP');
      setIsPictureInPictureActive(false);
      // Riprova play dopo un timeout come in VideoPlayerHls
      setTimeout(playVideo, 200);
    };

    const handleEnterPictureInPicture = () => {
      //console.log('[SingoloFlusso] Entrato in PiP');
      setIsPictureInPictureActive(true);
    };

    initializeHls();

    const videoElement = videoRef.current;
    if (videoElement) {
        // Aggiungi listener PiP (rimozione precedente implicita nel cleanup)
        videoElement.addEventListener('leavepictureinpicture', handleLeavePictureInPicture);
        videoElement.addEventListener('enterpictureinpicture', handleEnterPictureInPicture);
    }

    // Funzione di cleanup (identica a VideoPlayerHls)
    return () => {
      //console.log(`[SingoloFlusso] Cleanup per: ${videoStreaming || 'nessuna sorgente'}`);
      // Cancella il timeout se il componente viene smontato prima che scatti
      if (reloadTimeoutId) {
        clearTimeout(reloadTimeoutId);
        //console.log('[SingoloFlusso] Timeout di reload cancellato durante cleanup.');
      }

      if (videoElement) {
        videoElement.removeEventListener('leavepictureinpicture', handleLeavePictureInPicture);
        videoElement.removeEventListener('enterpictureinpicture', handleEnterPictureInPicture);
        // Rimuovi listener playVideo
        const listener = videoElement.__playVideoListener;
        if (listener) {
             videoElement.removeEventListener('loadedmetadata', listener);
        }
        videoElement.pause();
        videoElement.removeAttribute('src');
        videoElement.load();
      }
      if (hls) {
        //console.log('[SingoloFlusso] Distruggo istanza HLS');
        hls.destroy();
      }
    };
  // Dipendenze (identiche a VideoPlayerHls, usando la prop videoStreaming)
  }, [videoStreaming, reloadTrigger, isPictureInPictureActive]); 

  return (
    <video
      autoPlay // Come in VideoPlayerHls
      // muted // Rimosso, come in VideoPlayerHls
      playsInline // Mantenuto per iOS
      controls // Come in VideoPlayerHls
      ref={videoRef}
      className="custom-video-player-pc" // Come in VideoPlayerHls
      key={reloadTrigger} // Come in VideoPlayerHls
      style={{ backgroundColor: '#000' }} // Mantenuto per stile base
      // crossOrigin="anonymous" // Rimosso, non presente in VideoPlayerHls
    ></video>
  );
};

export default VideoPlayerHlsSingoloFlusso;